///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.itemDetails = abcsetup.itemDetails || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    // A hyperlink with item_description class and a data-id was clicked
    $(document).on('click', 'a.item_description[data-id]', function (e) {
        var _link = $(this);
        _link.css("cursor", "progress");

        var no_link = $(this).data('no-link') || null;
        var entity = $(this).data('entity') || 'abc_item';
        if (entity == 'front_store_item') {
            entity = 'front_store';
        }

        console.log('Load item details: /api/' + entity + '/' + _link.data('id'));

        axios.post('/api/' + entity + '/' + _link.data('id')).then(response => {
            _link.css('cursor', 'pointer');
            // console.log('response.data',response.data);

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            if (response.data && response.data.id) {
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    // trigger: 'focus',
                    container: 'body',
                    title: (response.data.description ? response.data.description : (response.data.name ? response.data.name : '')),
                    content: function () {
                        /*
                            <tr>\
                                <td>Description</td>\
                                <td>' + response.data.description + '</td>\
                            </tr>';
                        */

                        var table = '<h5>Item Details</h5>\
                                     <table class="table table-sm table-striped table-bordered">';

                        if (response.data.mat_descr) {
                            table = table + '<tr>\
                                        <td>40 Character Description</td>\
                                        <td>' + response.data.mat_descr + '</td>\
                                    </tr>';
                        }

                        if (entity == 'abc_item') {
                            if (response.data.mat_eff_date) {
                                table = table + '<tr>\
                                            <td>Eff. Date</td>\
                                            <td>' + response.data.mat_eff_date + '</td>\
                                        </tr>';
                            }

                            if (response.data.sap_num) {
                                table = table + '<tr>\
                                            <td>SAP #</td>\
                                            <td>' + response.data.sap_num + '</td>\
                                        </tr>';
                            }

                            if (response.data.abc_6_digit) {
                                table = table + '<tr>\
                                            <td>COR 6-Digit</td>\
                                            <td>' + response.data.abc_6_digit + '</td>\
                                        </tr>';
                            }

                            if (response.data.hdsmith_num) {
                                table = table + '<tr>\
                                            <td>HDSmith #</td>\
                                            <td>' + response.data.hdsmith_num + '</td>\
                                        </tr>';
                            }

                            if (response.data.retail_upc) {
                                table = table + '<tr>\
                                            <td>Retail UPC</td>\
                                            <td>' + response.data.retail_upc + '</td>\
                                        </tr>';
                            }

                            if (response.data.mat_status) {
                                table = table + '<tr>\
                                            <td>Mat. Status</td>\
                                            <td>' + response.data.mat_status + '</td>\
                                        </tr>';
                            }

                        }

                        if (response.data.category_name) {
                            table = table + '<tr>\
                                        <td>Category</td>\
                                        <td>' + response.data.category_name + '</td>\
                                    </tr>';
                        }

                        table = table + '<tr>\
                                            <td>Supplier</td>\
                                            <td>' + response.data.vendor_name + '</td>\
                                        </tr>\
                                        <tr>\
                                            <td>Type</td>\
                                            <td>' + response.data.type_name + '</td>\
                                        </tr>\
                                        </tr>\
                                            <td>Supplier ID</td>\
                                            <td>' + response.data.vendor_id + '</td>\
                                        </tr>';

                        if (response.data.abbr_descr) {
                            table = table + '<tr>\
                                        <td>Abbreviated Description</td>\
                                        <td>' + response.data.abbr_descr + '</td>\
                                    </tr>';
                        }

                        if (entity == 'abc_item') {
                            if (response.data.ext_descr) {
                                table = table + '<tr>\
                                            <td>Extended Description</td>\
                                            <td>' + response.data.ext_descr + '</td>\
                                        </tr>';
                            }

                            if (response.data.qualifier_code) {
                                table = table + '<tr>\
                                            <td>Qualifier Code</td>\
                                            <td>' + response.data.qualifier_code + '</td>\
                                        </tr>';
                            }

                            if (response.data.mat_group) {
                                table = table + '<tr>\
                                            <td>Mat. Group</td>\
                                            <td>' + response.data.mat_group + '</td>\
                                        </tr>';
                            }

                            if (response.data.sap_mat_create_date) {
                                table = table + '<tr>\
                                            <td>SAP Create Date</td>\
                                            <td>' + response.data.sap_mat_create_date + '</td>\
                                        </tr>';
                            }

                            if (response.data.upc11) {
                                table = table + '<tr>\
                                            <td>UPC</td>\
                                            <td>' + response.data.upc11 + '</td>\
                                        </tr>';
                            }
                            if (response.data.ndc11) {
                                table = table + '<tr>\
                                            <td>NDC</td>\
                                            <td>' + response.data.ndc11 + '</td>\
                                        </tr>';
                            }

                            if (response.data.vc) {
                                table = table + '<tr>\
                                            <td>VC</td>\
                                            <td>' + response.data.vc + '</td>\
                                        </tr>';
                            }

                            if (response.data.abc_matl_replace) {
                                table = table + '<tr>\
                                            <td>Replace Date</td>\
                                            <td>' + response.data.abc_matl_replace + '</td>\
                                        </tr>';
                            }
                        }

                        if (entity == 'rx_item') {
                            table = table + '<tr>\
                                        <td>Sellling Unit NDC</td>\
                                        <td>' + response.data.selling_unit_ndc + '</td>\
                                    </tr>';
                        }

                        if (response.data.subcategory_name) {
                            table = table + '<tr>\
                                        <td>Subcategory</td>\
                                        <td>' + response.data.subcategory_name + '</td>\
                                    </tr>';
                        }

                        if (response.data.segment_name) {
                            table = table + '<tr>\
                                        <td>Segment</td>\
                                        <td>' + response.data.segment_name + '</td>\
                                    </tr>';
                        }

                        if (entity == 'front_store') {
                            table = table + '<tr>\
                                            <td>SAP Material Group</td>\
                                            <td>' + response.data.mat_group + '</td>\
                                        </tr>';
                        }

                        if (response.data.category_manager_name) {
                            table = table + '<tr>\
                                        <td>Category Manager</td>\
                                        <td>' + response.data.category_manager_name + '</td>\
                                    </tr>';
                        }

                        if (entity != 'abc_item') {
                            table = table + '<tr>\
                                            <td>Status</td>\
                                            <td>' + response.data.item_status_name + '</td>\
                                        </tr>\
                                        <tr>\
                                            <td>Date Created</td>\
                                            <td>' + moment(response.data.create_date, 'YYYY-MM-DD').format('MM/DD/YYYY') + '</td>\
                                        </tr>\
                                    </table>';
                        } else {
                            if (response.data.form) {
                                table = table + '<tr>\
                                            <td>Form</td>\
                                            <td>' + response.data.form + '</td>\
                                        </tr>';
                            }
                            if (response.data.unit_size_qty) {
                                table = table + '<tr>\
                                            <td>Unit Size Qty.</td>\
                                            <td>' + response.data.unit_size_qty + '</td>\
                                        </tr>';
                            }
                            if (response.data.unit_size) {
                                table = table + '<tr>\
                                            <td>Unit Size</td>\
                                            <td>' + response.data.unit_size + '</td>\
                                        </tr>';
                            }
                            if (response.data.unit_str_qty) {
                                table = table + '<tr>\
                                            <td>Unit Str. Qty.</td>\
                                            <td>' + response.data.unit_str_qty + '</td>\
                                        </tr>';
                            }
                            if (response.data.unit_str_code) {
                                table = table + '<tr>\
                                            <td>Unit Str. Code</td>\
                                            <td>' + response.data.unit_str_code + '</td>\
                                        </tr>';
                            }
                            if (response.data.unit_str) {
                                table = table + '<tr>\
                                            <td>Unit Str.</td>\
                                            <td>' + response.data.unit_str + '</td>\
                                        </tr>';
                            }
                            if (response.data.unit_dose_code) {
                                table = table + '<tr>\
                                            <td>Unit Dose Code</td>\
                                            <td>' + response.data.unit_dose_code + '</td>\
                                        </tr>';
                            }
                            if (response.data.order_unit) {
                                table = table + '<tr>\
                                            <td>Order Unit</td>\
                                            <td>' + response.data.order_unit + '</td>\
                                        </tr>';
                            }
                            if (response.data.wholesale_unit) {
                                table = table + '<tr>\
                                            <td>Wholesale Unit</td>\
                                            <td>' + response.data.wholesale_unit + '</td>\
                                        </tr>';
                            }
                            if (response.data.generic_code) {
                                table = table + '<tr>\
                                            <td>Generic Code</td>\
                                            <td>' + response.data.generic_code + '</td>\
                                        </tr>';
                            }
                            if (response.data.generic_name) {
                                table = table + '<tr>\
                                            <td>Generic Name</td>\
                                            <td>' + response.data.generic_name + '</td>\
                                        </tr>';
                            }
                            if (response.data.mfr_prod_code) {
                                table = table + '<tr>\
                                            <td>Mfg. Part Number</td>\
                                            <td>' + response.data.mfr_prod_code + '</td>\
                                        </tr>';
                            }
                            if (response.data.program_code) {
                                table = table + '<tr>\
                                            <td>Program Code</td>\
                                            <td>' + response.data.program_code + '</td>\
                                        </tr>';
                            }
                            if (response.data.priv_label_code) {
                                table = table + '<tr>\
                                            <td>Priv. Label Code</td>\
                                            <td>' + response.data.priv_label_code + '</td>\
                                        </tr>';
                            }
                            if (response.data.priv_label_name) {
                                table = table + '<tr>\
                                            <td>Priv. Label Name</td>\
                                            <td>' + response.data.priv_label_name + '</td>\
                                        </tr>';
                            }
                            if (response.data.retail_pack_qty) {
                                table = table + '<tr>\
                                            <td>Retail Pack Qty.</td>\
                                            <td>' + response.data.retail_pack_qty + '</td>\
                                        </tr>';
                            }
                            if (response.data.case_pack_qty) {
                                table = table + '<tr>\
                                            <td>Case Pack Qty.</td>\
                                            <td>' + response.data.case_pack_qty + '</td>\
                                        </tr>';
                            }
                            if (response.data.wholesale_pack_type) {
                                table = table + '<tr>\
                                            <td>Wholesale Pack Type</td>\
                                            <td>' + response.data.wholesale_pack_type + '</td>\
                                        </tr>';
                            }
                            if (response.data.wac) {
                                table = table + '<tr>\
                                            <td>WAC</td>\
                                            <td>' + response.data.wac + '</td>\
                                        </tr>';
                            }
                            if (response.data.map_price) {
                                table = table + '<tr>\
                                            <td>MAP</td>\
                                            <td>' + response.data.map_price + '</td>\
                                        </tr>';
                            }
                            if (response.data.msrp) {
                                table = table + '<tr>\
                                            <td>MSRP</td>\
                                            <td>' + response.data.msrp + '</td>\
                                        </tr>';
                            }
                            if (response.data.zbcs) {
                                table = table + '<tr>\
                                            <td>ZBCS</td>\
                                            <td>' + response.data.zbcs + '</td>\
                                        </tr>';
                            }
                            if (response.data.last_ship_date) {
                                table = table + '<tr>\
                                            <td>Last Ship Date</td>\
                                            <td>' + response.data.last_ship_date + '</td>\
                                        </tr>';
                            }
                            if (response.data.first_ship_date) {
                                table = table + '<tr>\
                                            <td>First Ship Date</td>\
                                            <td>' + response.data.first_ship_date + '</td>\
                                        </tr>';
                            }
                            if (response.data.planogram) {
                                table = table + '<tr>\
                                            <td>In Planogram</td>\
                                            <td>' + response.data.planogram + '</td>\
                                        </tr>';
                            }
                            if (response.data.pog_predom) {
                                table = table + '<tr>\
                                            <td>Predom. Planogram</td>\
                                            <td>' + response.data.pog_predom + '</td>\
                                        </tr>';
                            }
                            if (response.data.new_item_pr_registration) {
                                table = table + '<tr>\
                                            <td>New Item PR Reg.</td>\
                                            <td>' + response.data.new_item_pr_registration + '</td>\
                                        </tr>';
                            }
                        }
                        if (entity != 'abc_item') {
                            table = !no_link ? table + '<div class="text-right"><a href="/' + entity + '/' + _link.data('id') + '" class="btn btn-info btn-sm">View Item Details</a></div>' : table;
                        }
                        return '<div class="item_description">' + table + '</div>';

                    },
                }).popover('show');
            }
        });

        return false;
    });


    // A hyperlink with rfq_bid_request_items class and a data-id was clicked
    $(document).on('click', 'a.rfq_bid_request_items[data-id]', function (e) {
        var _link = $(this);
        _link.css("cursor", "progress");

        console.log('Load item details: /api/rfq/bid_requests/' + _link.data('id'));

        axios.post('/api/rfq/bid_requests/' + _link.data('id')).then(response => {
            _link.css('cursor', 'pointer');

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            //alert(JSON.stringify(response.data));
            if (response.data && (response.data.coupa_products || response.data.r_f_q_bid_type.unsolicited)) {
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    // If trigger is set to focus, popover will be dismissed on next click
                    // trigger: 'focus',
                    container: 'body',
                    title: response.data.name,
                    content: function () {
                        if (response.data.r_f_q_bid_type.unsolicited) {
                            var table = '<h5>Items Submitted</h5>\
                                        <table class="table table-sm table-striped table-bordered">\
                                            <thead>\
                                                <th>Description</th>\
                                                <th>Strength</th>\
                                                <th>Form</th>\
                                            </thead>';

                            $(response.data.r_f_q_bids).each(function () {
                                table += '<tr>\
                                            <td>' + this.itemdescfull + '</td>\
                                            <td>' + (this.strength ? this.strength : '') + '</td>\
                                            <td>' + (this.form ? this.form : '') + '</td>\
                                        </tr>';
                            });

                        } else {
                            var table = '<h5>Items Sent</h5>\
                                        <table class="table table-sm table-striped table-bordered">\
                                            <thead>\
                                                <th>SAP #</th>\
                                                <th>Description</th>\
                                                <th>Strength</th>\
                                                <th>Form</th>\
                                            </thead>';

                            $(response.data.coupa_products).each(function () {
                                table += '<tr>\
                                            <td>' + this.abc8 + '</td>\
                                            <td>' + this.itemdescfull + '</td>\
                                            <td>' + (this.strength ? this.strength : '') + '</td>\
                                            <td>' + (this.form ? this.form : '') + '</td>\
                                        </tr>';
                            });
                        }

                        return '<div class="item_description">' + table + '</div>';
                    },
                }).popover('show');
            }
        });

        return false;
    });


    // A hyperlink with rfq_bid_request_suppliers class and a data-id was clicked
    $(document).on('click', 'a.rfq_bid_request_suppliers[data-id]', function (e) {
        var _link = $(this);
        _link.css("cursor", "progress");

        console.log('Load item details: /api/rfq/bid_requests/' + _link.data('id'));

        axios.post('/api/rfq/bid_requests/' + _link.data('id')).then(response => {
            _link.css('cursor', 'pointer');

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            //alert(JSON.stringify(response.data.suppliers));
            if (response.data && response.data.suppliers) {
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    // If trigger is set to focus, popover will be dismissed on next click
                    // trigger: 'focus',
                    container: 'body',
                    title: response.data.name,
                    content: function () {
                        var table = '<h5>Suppliers</h5>\
                                     <table class="table table-sm table-striped table-bordered">\
                                        <thead>\
                                            <th>ID</th>\
                                            <th>Name</th>\
                                        </thead>';

                        $(response.data.suppliers).each(function () {
                            table += '<tr>\
                                        <td>' + this.vendor_id + '</td>\
                                        <td>' + this.name + '</td>\
                                    </tr>';
                        });

                        return '<div class="item_description">' + table + '</div>';
                    },
                }).popover('show');
            }
        });

        return false;
    });


    // A hyperlink with consumer_rfp_items class and a data-id was clicked
    $(document).on('click', 'a.consumer_rfp_items[data-id]', event => {
        const _link = $(event.target);
        _link.css('cursor', 'progress');

        axios.get(`/api/consumer_rfp/${_link.data('id')}/item`).then(response => {
            _link.css('cursor', 'pointer');

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            if (response.data && response.data.items) {
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    trigger: 'focus',
                    container: 'body',
                    title: response.data.consumer_rfp.ConsumerRFPType.name,
                    content() {
                        const itemsTable = `<h5>Items Sent</h5><table class="table table-sm table-striped table-bordered">
                        <thead>
                            <th>SAP #</th>
                            <th>Description</th>
                        </thead>
                        <tbody>
                        ${response.data.items.map(item =>
                            `<tr>
                                 <td>${item.sap_num}</td>
                                 <td>${item.mat_descr}</td>
                             </tr>`
                        ).join('')}
                        </tbody>
                        </table>`;

                        const customItemsTable = `<h5>Other Items Sent</h5><table class="table table-sm table-striped table-bordered">
                        <thead>
                            <th>Description</th>
                        </thead>
                        <tbody>
                        ${response.data.custom_items.map(item =>
                            `<tr>
                                 <td>${item.description}</td>
                             </tr>`
                        ).join('')}
                        </tbody>
                        </table>`;

                        return `<div class="item_description">${response.data.items.length ? itemsTable : ''}${response.data.custom_items.length ? customItemsTable : ''}</div>`;
                    },
                }).popover('show');
            }
        });

        return false;
    });

    // A hyperlink with unsolicited_consumer_rfp_items class and a data-id was clicked
    $(document).on('click', 'a.unsolicited_consumer_rfp_items[data-id]', event => {
        const _link = $(event.target);
        _link.css('cursor', 'progress');

        axios.get(`/api/consumer_rfp/${_link.data('id')}/unsolicited_item`).then(response => {
            _link.css('cursor', 'pointer');

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            if (response.data && response.data.items) {
                console.log("fired", response.data, response.data.items);
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    trigger: 'focus',
                    container: 'body',
                    title: response.data.consumer_rfp.ConsumerRFPType.name,
                    content() {
                        const itemsTable = `<h5>Items</h5><table class="table table-sm table-striped table-bordered">
                        <thead>
                            <th>Description</th>
                        </thead>
                        <tbody>
                        ${response.data.items.map(item =>
                            `<tr>
                                 <td>${item.unsolicited_item_description}</td>
                             </tr>`
                        ).join('')}
                        </tbody>
                        </table>`;

                        return `<div class="item_description">${response.data.items.length ? itemsTable : ''}</div>`;
                    },
                }).popover('show');
            }
        });

        return false;
    });


    // A hyperlink with consumer_rfp_suppliers class and a data-id was clicked
    $(document).on('click', 'a.consumer_rfp_suppliers[data-id]', event => {
        const _link = $(event.target);
        _link.css('cursor', 'progress');

        axios.get(`/api/consumer_rfp/${_link.data('id')}/supplier`).then(response => {
            _link.css('cursor', 'pointer');

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            if (response.data && (response.data.suppliers || response.data.new_suppliers)) {
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    trigger: 'focus',
                    container: 'body',
                    title: response.data.consumer_rfp.ConsumerRFPType.name,
                    content() {
                        const suppliersTable = `<h5>Suppliers</h5><table class="table table-sm table-striped table-bordered">
                        ${response.data.suppliers.map(supplier =>
                            `<tr>
                                 <td>${supplier.vendor_id || ''}</td>
                                 <td>${supplier.name}</td>
                             </tr>`
                        ).join('')}
                        </table>`;

                        const newSuppliersTable = `<h5>Invited New Suppliers</h5><table class="table table-sm table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Last Invite Sent On</th>
                            </tr>
                        </thead>
                        <tbody>
                        ${response.data.new_suppliers.map(supplier =>
                            `<tr>
                                 <td>${supplier.user.email}</td>
                                 <td>${supplier.absetup_invite_last_sent_at ? moment(supplier.absetup_invite_last_sent_at).format('MMM D, YYYY') : '<em>None yet</em>'}</td>
                             </tr>`
                        ).join('')}
                        </tbody>
                        </table>`;

                        return `<div class="item_description">
                                    ${response.data.suppliers.length ? suppliersTable : ''}
                                    ${response.data.new_suppliers.length ? newSuppliersTable : ''}
                                    ${!response.data.new_suppliers.length && !response.data.suppliers.length ? '<em>No new suppliers were invited.</em>' : ''}
                                </div>`;
                    },
                }).popover('show');
            }
        });

        return false;
    });


    // A hyperlink with thoughtspot_invite_history class and a data-id was clicked
    $(document).on('click', 'a.thoughtspot_invite_history[data-thoughtspot_registration_id]', function (e) {
        var _link = $(this);
        _link.css("cursor", "progress");

        const url = `/api/thoughtspot/invitations/alerts_sent/${_link.data('thoughtspot_registration_id')}`
        console.log('Load item details: ' + url);

        axios.get(url).then(response => {
            console.warn('response.data', response.data);
            _link.css('cursor', 'pointer');

            // TODO: destroy the popover before re-creating it
            if (_link.hasClass('item_popover')) {
                //_link.popover('destroy');
            }

            if (response.data && Array.isArray(response.data.emails) && response.data.emails.length) {
                _link.addClass('item_popover').popover({
                    //placement: 'top',
                    html: true,
                    trigger: 'focus',
                    container: 'body',
                    title: 'Invitation History',
                    content: function () {
                        let table = '<table class="table table-sm table-striped table-bordered">\
                                        <thead>\
                                            <th>Date Sent</th>\
                                        </thead>';

                        response.data.emails.forEach(email => {
                            const date = moment.utc(email.delivery_date, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DD hh:mm:ssA');

                            table += '<tr>\
                                        <td>' + date + '</td>\
                                    </tr>';
                        });

                        return '<div class="item_description">' + table + '</div>';
                    },
                }).popover('show');
            }
        });

        return false;
    });




    // Hide the popover, but only if the user clicked outside of it
    $('body').on('click', function (e) {
        $('a.item_description[data-id]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
});
